export class Constants {
    // css classNames
    static cssClass_hidden = "hidden";
    static cssClass_greyedOut = "greyed-out";
    static cssClass_contentStandard = "content-standard";

    static cssClass_dragHighlighted = "drag-highlighted";

    static cssClass_bootstrapShow = "show";
    static cssClass_bootstrapActive = "active";
}